import React from 'react'
import { cn } from '~/lib/common-utils'

type ContainerProps = {
  children: React.ReactNode
  className?: string
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '7xl' | 'full' | 'default'
  paddingX?: 'sm' | 'md' | 'lg' | 'xl' | 'none'
  paddingY?: 'sm' | 'md' | 'lg' | 'xl' | 'none'
}

export default function Container({
  children,
  className,
  maxWidth = 'default',
  paddingX = 'lg',
  paddingY = 'lg',
}: ContainerProps) {
  const maxWidthClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl',
    '7xl': 'max-w-7xl',
    default: 'max-w-screen',
    full: 'max-w-full',
  }

  const paddingXClasses = {
    none: 'px-0',
    sm: 'px-4',
    md: 'px-6',
    lg: 'px-4 md:px-0',
    xl: 'px-16',
  }

  const paddingYClasses = {
    none: 'py-0',
    sm: 'py-4',
    md: 'py-6 md:py-8',
    lg: 'py-6 md:py-12',
    xl: 'py-6 md:py-24',
  }

  return (
    <div
      className={cn(
        'max-w-container mx-auto w-full',
        maxWidthClasses[maxWidth],
        paddingXClasses[paddingX],
        paddingYClasses[paddingY],
        className
      )}
    >
      {children}
    </div>
  )
}
